<template>
  <Select
    v-model="inches"
    :options="heightOptions"
    option-label="label"
    option-value="value"
  />
</template>

<script setup lang="ts">
import { computed } from "vue";
import Select from "primevue/select";

const props = defineProps<{
  min: number;
  max: number;
}>();

const inches = defineModel<number | null>();

const heightOptions = computed(() => {
  return Array.from({ length: props.max - props.min + 1 }, (_, i) => {
    const totalInches = props.min + i;
    const feet = Math.floor(totalInches / 12);
    const remainingInches = totalInches % 12;
    return {
      label: `${feet}'${remainingInches}"`,
      value: totalInches,
    };
  });
});
</script>
